export default {
    props: [],

    methods: {
        redirectToMain() {
            this.$router.push({ name: 'resources' })
        },

        close() {
            this.$emit('close', true);
        },
    },
};
